import { useTranslation } from "react-i18next";

import { Link as RouterLink } from "react-router-dom";
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    CardActions,
    Link,
    Stack,
} from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Translations } from "../localization/translations";

interface IClassifierCardProps {
    to: string;
    img?: string;
    title?: string;
    content?: React.ReactNode;
}

const ClassifierCard: React.FC<IClassifierCardProps> = ({
    to,
    img,
    title,
    content,
}) => {
    const { t } = useTranslation();
    return (
        <Card elevation={0} sx={{ borderRadius: 0 }}>
            {img ? (
                <CardMedia
                    component="img"
                    image={`data:image/jpeg;base64,${img}`}
                    alt="classifier image"
                    style={{ maxWidth: 360 }}
                    sx={{ paddingBottom: 2 }}
                />
            ) : null}

            <CardContent sx={{ padding: 0 }}>
                {title ? (
                    <Typography
                        variant="h5"
                        color="primary"
                        sx={{ paddingBottom: 4 }}
                    >
                        {title}
                    </Typography>
                ) : null}
                {content ? (
                    <Typography component="div">{content}</Typography>
                ) : null}
            </CardContent>
            <CardActions sx={{ padding: 0, paddingTop: 2 }}>
                <Link component={RouterLink} to={to}>
                    <Stack direction="row">
                        {t(Translations.classifier.label.learnMore)} <ArrowForwardIcon />
                    </Stack>
                </Link>
            </CardActions>
        </Card>
    );
};

export default ClassifierCard;
